var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticClass:"fa-ul"},_vm._l((_vm.listOfSubmittals),function(submittal){return (_vm.$route.params.submittalID != submittal.id)?_c('li',[_c('a',{attrs:{"href":_vm.getUrl(submittal.id)}},[_c('i',{staticClass:"fa-li fa fa-file-o"}),_vm._v(" "+_vm._s(submittal.name)+"\n            ")])]):_vm._e()}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }